import { Button, Card, Col, Flex, Row, Tabs } from 'antd';
import React from 'react';
import PageTitle from '../../components/PageTitle';
import IntlMessage from '../../components/IntlMessage';
import Overview from './overview';
import Report from './report';

const Cashier = () => {
  const tabs = [
    {
      key: '1',
      label: <IntlMessage id="global.overview" />,
      children: <Overview />,
    },
    {
      key: '2',
      label: <IntlMessage id="global.cashier" />,
      children: <Report />,
    },
  ];

  return (
    <Card>
      <Tabs
        defaultActiveKey="1"
        type="line"
        size="large"
        items={tabs}
        centered
        destroyInactiveTabPane={true}
      />
    </Card>
  );
};

export default Cashier;
